module.exports = __webpack_public_path__ + "media/noYTO.5c697130.wav";